import { loadStripe } from '@stripe/stripe-js/pure';
import type { Stripe } from '@stripe/stripe-js';
import { stripeId } from '../../constants/evs/stripeToken';
interface CardNetwork {
  key: string;
  value: string;
  text: string;
  name: string;
}
interface RetrieveCardNetworksResult {
  networks: string[];
}

export const getCardNetwork = async (cardNumber: string): Promise<CardNetwork[] | null> => {
  try {
    const stripe: Stripe | null = await loadStripe(stripeId ?? '');
    const { networks }: RetrieveCardNetworksResult = await (stripe as any).retrieveCardNetworks(
      cardNumber
    );
    return networks.map((network: string) => {
      const networkUpperCase = network.toUpperCase();
      return {
        key: networkUpperCase,
        value: networkUpperCase,
        text: networkUpperCase,
        name: network.replace('_', ' ').replace(/\b\w/g, (char: string) => char.toUpperCase())
      };
    });
  } catch (error) {
    //eslint-disable-next-line
    console.error('Error fetching card networks:', error);
    return [];
  }
};
